module.exports = __webpack_public_path__ + "assets/img/bg-male-75bf1b98.png";